import {
  formatCurrency,
  formatDate,
  formatStringUCW
} from "app/DealMachineCore/actions/CommonFunctions";
import { Bold, Copy, Row, Wrapper } from "app/NativeComponents/common";
import { InformationItem } from "app/NativeComponents/snippets";
import React from "react";
import { useSelector } from "react-redux";

export const CompItem = ({ comp, onSelect, open = false }) => {
  const { colors } = useSelector(({ settings }) => settings);

  const onPress = () => {
    if (onSelect) onSelect();
  };

  return (
    <div
      onClick={onPress}
      style={{
        ...{
          transition: "all 0.2s",
          width: "100%",
          marginBottom: 6,
          cursor: "pointer",
          borderLeft: `0px solid ${colors.active_color}`,
          backgroundColor: "#fff"
        },
        ...(open
          ? {
              borderLeftWidth: 5,
              backgroundColor: colors.background_color
            }
          : { borderLeftWidth: 0 })
      }}
    >
      <Wrapper style={{ padding: 12 }}>
        <Row
          style={{
            alignSelf: "stretch",
            justifyContent: "space-between"
          }}
        >
          <Copy style={{ color: colors.text_button_color }}>
            <Bold>{formatStringUCW(comp.Address)}</Bold>
          </Copy>
          <Copy style={{ color: colors.text_button_color }}>
            <Bold>
              {formatCurrency(comp.AssessorLastSaleAmount || 0).split(".")[0]}
            </Bold>
          </Copy>
        </Row>
        <Row
          style={{
            alignSelf: "stretch",
            justifyContent: "space-between"
          }}
        >
          <Wrapper>
            <Copy>
              {formatStringUCW(comp.propertyaddress_city)},{" "}
              {comp.propertyaddress_state} {comp.propertyaddress_Zip}
            </Copy>
          </Wrapper>
          <Copy>{formatDate(comp.AssessorLastSaleDate)}</Copy>
        </Row>
        {/* Expanded info */}
        <Wrapper style={{ flex: 1, paddingTop: 10 }}>
          <Row style={{ flex: 1, justifyContent: "space-between" }}>
            <InformationItem
              size="small"
              item={comp.building_bedrooms}
              label={"Bedrooms:"}
              format="number"
            />
            <InformationItem
              size="small"
              item={Number(comp.building_totalbaths || 0).toFixed(1)}
              label={"Baths:"}
              format="number"
            />
            <InformationItem
              size="small"
              item={comp.AreaBuilding}
              label={"Square footage:"}
              format="feet"
            />
          </Row>
        </Wrapper>
      </Wrapper>
    </div>
  );
};
